import {HttpHeaders} from '@angular/common/http';
import {
  AddTerminalResponse,
  Configuration,
  DirectoryV2ServiceInterface,
  GetOrganizationResponse,
  GetTrunksResponse,
  Response,
  SearchOrganizationResponse,
  ServiceNumberDataResponse,
  Terminal,
  TerminalsResponse
} from '@gt-api';
import {ServiceNumberDataMock} from '@testhelper/mocks/service-number-data.mock';
import {Observable, of} from 'rxjs';

export class DirectoryV2ServiceStub implements DirectoryV2ServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getOrganization2(organization?: string): Observable<GetOrganizationResponse> {
    return undefined;
  }

  getServiceNumberData1(
    organization?: string,
    serviceNumber?: string,
    extraHttpRequestParams?: any
  ): Observable<ServiceNumberDataResponse> {
    return of({code: 200, serviceNumberData: ServiceNumberDataMock.getServiceNumberData()});
  }

  searchOrganization2(
    organization?: string,
    organizationId?: string,
    organizationName?: string,
    entriesPerPage?: number,
    page?: number
  ): Observable<SearchOrganizationResponse> {
    return undefined;
  }

  getTerminals1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<TerminalsResponse> {
    return undefined;
  }

  addTerminal1(organization?: string, login?: string, body?: Terminal, extraHttpRequestParams?: any): Observable<AddTerminalResponse> {
    return undefined;
  }

  editTerminal1(organization?: string, login?: string, body?: Terminal, extraHttpRequestParams?: any): Observable<Response> {
    return undefined;
  }

  getTrunks1(extraHttpRequestParams?: any): Observable<GetTrunksResponse> {
    return undefined;
  }

  removeTerminal1(fullNumber: string, organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return undefined;
  }
}
